import { ArrowLeftIcon, WarningIcon } from "@phosphor-icons/react";

export function NotFoundPage({ onHome }: { onHome: () => void }) {
  return (
    <section className="not-found">
      <WarningIcon size={42} weight="thin" />
      <samp>HTTP 404</samp>
      <h1>Раздел не найден</h1>
      <p>Маршрут не существует или недоступен вашей роли.</p>
      <button className="button primary" onClick={onHome}><ArrowLeftIcon size={17} />К обзору</button>
    </section>
  );
}
